"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fontSize = exports.width = exports.showCursorPosition = exports.showGlyphBorders = void 0;
const nanostores_1 = require("nanostores");
const clamp_1 = __importDefault(require("lodash/clamp"));
exports.showGlyphBorders = createCheckboxStore("show-glyph-borders");
exports.showCursorPosition = createCheckboxStore("show-cursor-position");
exports.width = createNumericInputStore("#width", [400, 800]);
exports.fontSize = createNumericInputStore("#font-size", [10, 72]);
exports.showCursorPosition.subscribe((showCursor) => {
    const canvas = document.querySelector("canvas");
    if (canvas) {
        canvas.style.cursor = showCursor ? "none" : "text";
    }
});
function createCheckboxStore(selector) {
    const element = document.getElementById(selector);
    const store = (0, nanostores_1.atom)(element.checked);
    element.addEventListener("change", () => {
        store.set(element.checked);
    });
    return store;
}
function createNumericInputStore(selector, range) {
    const element = document.querySelector(selector);
    const initialValue = (0, clamp_1.default)(parseInt(element.value, 10), ...range);
    const store = (0, nanostores_1.atom)(initialValue);
    element.value = initialValue.toString();
    element.addEventListener("change", () => {
        const value = (0, clamp_1.default)(parseInt(element.value, 10), ...range);
        store.set(value);
        element.value = value.toString();
    });
    return store;
}
